import React, {useContext, useEffect, useState} from 'react';
import Container from "../Container";
import {
    Button,
    Card,
    Descriptions,
    Divider,
    Form,
    Input,
    Modal,
    notification,
    Space,
    Table,
    Tag,
    Typography,
    Upload,
} from 'antd';
import type {ColumnsType} from 'antd/es/table';
import {downloadBase64File} from "./helper"
import Api from "../../utilis/api/service";
import AuthContext from "../../utilis/contexts/AuthContext";
import {UploadOutlined} from "@ant-design/icons";
import {RcFile} from "antd/es/upload/interface";

const {Title} = Typography

interface DataType {
    trace_number: string,
    key: string;
    name: string;
    mobile: string;
    national_code: string,
    company_national_code: string,
    company_name: string,
    user_type: "Individual" | "Company"
    father_name: string,
    address: string,
    birth_date: string,
    subject: string,
    created_at: string,
    attachment: string,
    answer_description: string | null,
    answer_attachment: string | null,
}

const {TextArea} = Input;
const RegisteredLetterList = () => {
    const columns: ColumnsType<DataType> = [
        {
            title: 'ردیف',
            dataIndex: 'index',
            key: 'index',
            render: (_, record, index) => {
                return <span className="text-sm">{index + 1}</span>
            },
        },
        {
            title: 'نوع شخص',
            dataIndex: 'user_type',
            key: 'userType',
            render: value => {
                if (value === 'Individual') {
                    return <Tag color="success">حقیقی</Tag>
                }
                return <Tag color="red">حقوقی</Tag>
            },
        },
        {
            title: 'تاریخ درخواست',
            dataIndex: 'created_at',
            key: 'createdAt',
            render: text => <span className="text-sm">{text}</span>,
        }, {
            title: 'شناسه پیگیری',
            dataIndex: 'trace_number',
            key: 'traceNumber',
            render: text => <span className="text-sm">{text}</span>,
        },

        {
            title: 'نام',
            dataIndex: 'name',
            key: 'name',
            render: text => <span className="text-sm">{text}</span>,
        },
        {
            title: 'شماره موبایل',
            dataIndex: 'mobile',
            key: 'mobile',
            render: text => <span className="text-sm">{text}</span>,
        },
        {
            title: 'کد ملی',
            dataIndex: 'national_code',
            key: 'nationalCode',
            render: text => <span className="text-sm">{text}</span>,
        },

        {
            title: 'توضیحات درخواست',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'اطلاعات کامل',
            key: 'action',
            render: (_, record) => (<div className="flex gap-2">
                <Button size="small" onClick={() => handleShowInfo(record)} type="primary">جزییات</Button>
                {!record.answer_description &&     <Button size="small" onClick={() => handleShowAnswerModal(record)}
                                                          type="default">ارسال پاسخ</Button>}
            </div>)
        }

    ];
    const handleShowAnswerModal = (data: DataType) => {
        setCurrentInfo(data);
        setAnswerModal(true)
    }
    const [showModal, setShowModal] = useState(false);
    const [showAnswerModal, setAnswerModal] = useState(false)
    const [currentInfo, setCurrentInfo] = useState<DataType | null>(null);
    const [letters, setLetters] = useState<DataType[]>([])
    const authContext = useContext(AuthContext);
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [fileBase64, setFileBase64] = useState<string | null>(null);
    const [fileList, setFileList] = useState<RcFile[]>([]);
    const [answerLoading, setAnswerLoading] = useState(false);
    const [form] = Form.useForm();
    const handleGetData = () => {
        setLoading(true)
        Api.post('/GetLetters', {
            Cellphone: authContext?.user?.cellphone || '',
        }, {
            headers: {
                "Authorization": authContext?.Token?.tokenType + " " + authContext?.Token?.accessToken
            }
        }).then(response => {

            if (response.data.Status == 0) {
                setError(false);
                setErrorMessage('');
                if (response.data.Data) {
                    if (response.data.Data.letters) {
                        setLetters(response.data.Data.letters)
                    } else {
                        setLetters([])
                    }
                } else {
                    setLetters([])
                }
            } else {
                setErrorMessage(response.data.message || 'خطا در دریافت اطلاعات')
                setError(true)
            }
        }).catch(error => {
            setError(true);
            setErrorMessage('خطا در دریافت اطلاعات')
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleSubmitAnswer = (value: any) => {
        if (!fileBase64) {
            if (!fileBase64) {
                notification['error']({
                    message: 'فایل پاسخ را انتخاب کنید',
                    duration: 120
                });
                return;
            }
        }
        const data = {
            Description: value.answerDescription,
            Cellphone: authContext.user?.cellphone,
            Attachment: fileBase64,
            TraceNumber:currentInfo?.trace_number,
        }

        setAnswerLoading(true);
        Api.post('AnswerLetter', data, {
            headers: {
                "Authorization": 'Bearer' + " " + authContext?.Token?.accessToken
            }
        }).then(response => {
            if (response.data) {
                if (response.data.Status === -1) {
                    notification['error']({
                        message: response.data?.Message,
                        duration: 120
                    });
                } else {
                    setFileList([]);
                    setFileBase64(null);
                    form.resetFields();
                    setAnswerLoading(false);
                    setCurrentInfo(null);
                    setAnswerModal(false);
                    handleGetData();
                    notification['success']({
                        message: response.data?.Message,
                        duration: 120
                    });
                }
            }
        }).finally(() => {
            setAnswerLoading(false);
        })
    }
    useEffect(() => {
        if (authContext?.Token?.accessToken) {
            handleGetData();
        }

    }, [authContext?.Token?.accessToken]);
    const handleShowInfo = (data: DataType) => {
        setCurrentInfo(data);
        setShowModal(true);
    }
    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleBeforeUpload = async (file: RcFile): Promise<boolean> => {
        const isPdf = file.type === 'application/pdf';
        const isTif =
            file.type === 'image/tiff' ||
            file.name.endsWith('.tif') ||
            file.name.endsWith('.tiff');

        if (!isPdf && !isTif) {
            notification.error({
                message: 'تنها مجاز به ارسال فایل با فرمت tif , pdf می باشید.',
                duration: 5,
            });
            return false;
        }

        const base64 = await getBase64(file);
        setFileBase64(base64);
        setFileList([file]); // ✅ Add file manually only if valid
        return false; // Prevent auto-upload
    };
    const handleRemoveFileList = () => {
        setFileBase64(null)
        setFileList([]);
    }

    return <div className="w-full min-h-screen pt-10  bg-gray-100">
        <Container fluid={true}>
            <Card className="">
                <div className="flex justify-between items-center">
                    <Title level={4}> لیست درخواست ها</Title>

                </div>
            </Card>
            <Divider/>
            <div className="flex justify-center">
                {error && <Card className="max-w-md mx-auto w-full">
                    <div className="flex justify-center gap-2 items-center flex-col">
                        <h1 className="text-center font-bold text-xl text-red-500">خطا</h1>
                        <p className="mb-2">{errorMessage}</p>
                        <Button loading={loading} onClick={handleGetData} danger type="primary">تلاش مجدد</Button>
                    </div>
                </Card>}
            </div>
            {!error && <>
                <Card className="overflow-x-auto">
                    <Table  loading={loading} bordered={true} size="small" rowClassName="odd:bg-gray-100"
                           columns={columns} dataSource={letters}/>
                </Card>
                <Modal width={800} onCancel={() => {
                    form.resetFields();
                    setFileBase64(null);
                    setFileList([]);
                    setCurrentInfo(null);
                    setAnswerModal(false);
                    setAnswerLoading(false);


                }} footer={[]} open={showAnswerModal}>
                    <Title level={4}> پاسخ به درخواست ارباب رجوع </Title>
                    <Divider/>

                    <Descriptions size="small" column={{
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }} bordered>
                        <Descriptions.Item label="شناسه درخواست">
                            <span className="text-sm">{currentInfo?.trace_number || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="نوع شخص">
                        <span className="text-sm">
                            {currentInfo?.user_type == "Individual" && <Tag color="success">حقیقی</Tag>}
                            {currentInfo?.user_type == "Company" && <Tag color="red">حقوقی</Tag>}
                        </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="نام">
                            <span className="text-sm">{currentInfo?.name || '-'}</span>
                        </Descriptions.Item>
                    </Descriptions>
                    <Divider/>
                    <Form form={form} layout="vertical"
                          initialValues={{
                              answerDescription: '',
                          }} onFinish={handleSubmitAnswer}>
                        <Form.Item
                            className="col-span-2 lg:col-span-3 xl:col-span-4"
                            label="پاسخ "
                            name="answerDescription"
                            rules={[{required: true, message: 'توضیحات پاسخ الزامی است.'}, {
                                min: 10,
                                message: 'توضیحات پاسخ حداقل باید 10 کاراکتر باشد'
                            }]}
                        >
                            <TextArea

                                maxLength={500}
                                placeholder="توضیحات پاسخ را وارد کنید"
                                className="w-full"
                                size="large"
                            />
                        </Form.Item>
                        <div className="col-span-2 ">
                            <Upload className="w-full" onRemove={handleRemoveFileList} fileList={fileList} maxCount={1}
                                    beforeUpload={handleBeforeUpload} showUploadList={true}>
                                <Button
                                    className="flex w-full bg-gray-100 rounded-lg  justify-center items-center flex-col">
                                    فایل پاسخ
                                    <UploadOutlined/>
                                </Button>
                            </Upload>

                        </div>
                        <Divider/>
                        <Form.Item>
                            <Button loading={answerLoading} htmlType="submit" type="primary" className="w-full max-w-sm"
                                    size="large">
                                ثبت پاسخ
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal width={800} className="w-8/12" wrapClassName="w-full bg-black bg-opacity-30" footer={[]}
                       onCancel={() => {
                           setCurrentInfo(null);
                           setShowModal(false);
                       }} open={showModal}>
                    <Title level={4}> جزییات درخواست </Title>
                    <Typography>اطلاعات کامل درخواست</Typography>
                    <Divider/>
                    <Descriptions size="small"  column={{
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 2,
                        xl: 2,
                        xxl: 2,
                    }}  bordered>
                        <Descriptions.Item  label="شناسه درخواست">
                            <span className="text-sm">{currentInfo?.trace_number || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="تاریخ درخواست">
                            <span className="text-sm">{currentInfo?.created_at || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="نوع شخص">
                        <span className="text-sm">
                            {currentInfo?.user_type == "Individual" && <Tag color="success">حقیقی</Tag>}
                            {currentInfo?.user_type == "Company" && <Tag color="red">حقوقی</Tag>}
                        </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="نام">
                            <span className="text-sm">{currentInfo?.name || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="تاریخ تولد">
                            <span className="text-sm">{currentInfo?.birth_date || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item label="کد ملی">
                            <span className="text-sm">{currentInfo?.national_code || '-'}</span>
                        </Descriptions.Item>
                        <Descriptions.Item span={2} label="نام پدر">
                            <span className="text-sm">{currentInfo?.father_name || '-'}</span>
                        </Descriptions.Item>

                        {currentInfo?.company_national_code && <Descriptions.Item label="شناسه ملی شرکت">
                            <span className="text-sm">{currentInfo?.company_national_code || '-'}</span>
                        </Descriptions.Item>}
                        {currentInfo?.company_name && <Descriptions.Item label="نام شرکت">
                            <span className="text-sm">{currentInfo?.company_name || '-'}</span>
                        </Descriptions.Item>}
                        {currentInfo?.address && <Descriptions.Item span={2} label="آدرس">
                            <span className="text-sm">{currentInfo?.address || '-'}</span>
                        </Descriptions.Item>}
                        {currentInfo?.subject && <Descriptions.Item span={2} label="توضیحات درخواست">
                            <span className="text-sm">{currentInfo?.subject || '-'}</span>
                        </Descriptions.Item>}
                        {currentInfo?.attachment && <Descriptions.Item span={2} label="توضیحات درخواست">
                            <Button
                                onClick={() => downloadBase64File(currentInfo?.attachment || '', currentInfo?.trace_number || 'file')}>دانلود
                                فایل </Button>
                        </Descriptions.Item>}

                        {currentInfo?.answer_description && <Descriptions.Item span={2} label="پاسخ شما">
                            <span className="text-sm">{currentInfo?.answer_description || '-'}</span>
                        </Descriptions.Item>}
                        {currentInfo?.answer_attachment && <Descriptions.Item span={2} label="فایل پاسخ">
                            <Button
                                onClick={() => downloadBase64File(currentInfo?.answer_attachment || '', currentInfo?.trace_number+'_answer' || 'answer')}>دانلود
                                فایل </Button>
                        </Descriptions.Item>}
                    </Descriptions>
                </Modal>
            </>}


        </Container>
    </div>
}
export default RegisteredLetterList;